export function CheckedIcon(props: { class?: string }) {
  return (
    <svg
      class={props.class}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#035462" />
      <path
        d="M17.729 8.76611L10.479 16.0161L7.18359 12.7207"
        stroke="white"
        stroke-width="1.97727"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
